import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const documentsApi = baseApi.injectEndpoints({
  tagTypes: ["Documents"],
  endpoints: (builder) => ({
    getDocuments: builder.query({
      query: (params) => {
        return {
          url: `/documents/index.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetDocumentsQuery } = documentsApi;
